import * as React from 'react';
import NewRadio from '../../NewRadio/NewRadio';
import HStack from '../../HStack/HStack';
import Text from '../../Typography/Text/Text';

import { FilterComponentProps } from '../types';

export interface RadioOptionsProps<OptionType, FilterValueType extends any = string | null>
  extends FilterComponentProps<FilterValueType> {
  title?: string;
  getItemKey?: (item: OptionType) => string;
  getItemLabel?: (item: OptionType) => string;
  getItemValue?: (item: OptionType) => FilterValueType;
  options: OptionType[];
}

export const RadioOptionsFilter = <OptionType, T extends any>({
  getItemKey = item => String(item),
  getItemLabel = item => (item ? String(item) : 'No selection'),
  getItemValue = item => item as T,
  title = 'Select one',
  ...props
}: RadioOptionsProps<OptionType, T>) => {
  if (props.setValue === undefined) {
    throw new Error('RadioOptionsFilter: missing required props - did you forget to spread {...props}?');
  }

  return (
    <>
      {title && (
        <HStack spacing="4" alignY="center">
          <Text variant="body-2">{title}</Text>
        </HStack>
      )}
      {props.options.map(option => {
        const id = getItemKey(option);
        const label = getItemLabel(option);
        const value = getItemValue(option);

        return (
          <NewRadio
            id={id}
            key={id}
            label={label}
            name={title}
            value={String(value)}
            checked={props.value === value}
            onChange={() => props.setValue(value)}
          />
        );
      })}
    </>
  );
};

RadioOptionsFilter.displayName = 'GlobalFilter.RadioOptionsFilter';
